import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-image',
  template: `
    <div class="la-image">
      <img [src]="src" [alt]="alt" class="la-image__pic" [width]="width" [height]="height">
      <div class="la-image__content">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .la-image{display:inline-block;position:relative}.la-image__pic{width:100%;height:auto}.la-image__content{display:flex;width:100%;height:100%;position:absolute;left:0;top:0;align-items:center;justify-content:center}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaImageComponent {
  private _src: string;
  private _width: number;
  private _height: number;

  get width(): number {
    return this._width
  }

  @Input()
  set width(value: number) {
    this._width = value;
  }

  get height(): number {
    return this._height;
  }

  @Input()
  set height(value: number) {
    this._height = value;
  }

  get src(): string {
    return this._src;
  }

  @Input()
  set src(value: string) {
    this._src = value;
  }

  private _alt: string;

  get alt(): string {
    return this._alt;
  }

  @Input()
  set alt(value: string) {
    this._alt = value;
  }
}
